import { LDFlagSet } from 'launchdarkly-js-client-sdk'; // Adjust the import path as needed
import { IOrganisation } from '../onboarding/onboardingModels';

const orgFlagMatcher = (flag: string, orgToMatch: IOrganisation) => {
  return (
    flag.toLowerCase() === 'all' ||
    flag.toLowerCase() === orgToMatch?.id.toLowerCase() || // Returns true if the flag list id does NOT match the organization's id or name (case-insensitive). // This is used to determine if the organization is not present in the LaunchDarkly flag list, // which indicates it should use the new view of the PP portal. If the org is present, it's the old view
      flag.toLowerCase() === orgToMatch?.name.toLowerCase()
  );
};

export const getFeatureFlagValuebasedOnSIOrg = (
  key: string,
  flags: LDFlagSet | undefined,
  selectedOrganization: IOrganisation | null,
  organisations: IOrganisation[] | null
) => {
  let featureKey = false;
  const featureFlag = flags ? flags[key] : undefined;

  if (selectedOrganization && featureFlag && Array.isArray(featureFlag)) {
    featureKey = !featureFlag.some((flag: string) =>
      orgFlagMatcher(flag, selectedOrganization)
    );
  } else if (featureFlag && Array.isArray(featureFlag)) {
    const isFeatureFlagInOrganisations = organisations?.some(
      org =>
        org.zuoraAccountNo !== null &&
        !featureFlag.some(ffOrg => orgFlagMatcher(ffOrg, org))
    );
    featureKey = isFeatureFlagInOrganisations ? true : false;
  }
  return featureKey;
};

export const getFeatureFlagValuebasedOnSIOrgWhitelist = (
  key: string,
  flags: LDFlagSet | undefined,
  selectedOrganization: IOrganisation | null,
  organisations: IOrganisation[] | null
) => {
  if (selectedOrganization?.orgType?.toLowerCase() === 'customer') {
    return true;
  }

  let featureKey = false;
  const featureFlag = flags ? flags[key] : undefined;

  if (selectedOrganization && featureFlag && Array.isArray(featureFlag)) {
    featureKey = featureFlag.some((flag: string) =>
      orgFlagMatcher(flag, selectedOrganization)
    );
  } else if (featureFlag && Array.isArray(featureFlag)) {
    const isFeatureFlagInOrganisations = organisations?.some(
      org =>
        org.zuoraAccountNo !== null &&
        featureFlag.some(ffOrg => orgFlagMatcher(ffOrg, org))
    );
    featureKey = isFeatureFlagInOrganisations ? true : false;
  }
  return featureKey;
};

export const isFeatureFlagEnabledForUser = (
  key: string,
  flags: LDFlagSet | undefined,
  userId: string | undefined
): boolean => {
  if (!userId) {
    return false;
  }
  const featureFlag = flags ? flags[key] : undefined;
  if (featureFlag === undefined) {
    return false;
  }
  if (Array.isArray(featureFlag) && featureFlag.length === 0) {
    return true;
  }
  if (Array.isArray(featureFlag) && featureFlag.length > 0) {
    // Check if provided userId is in the list
    const isUserInList = featureFlag.some(
      (flagUserId: string) => flagUserId.toLowerCase() === userId.toLowerCase()
    );
    return isUserInList;
  }
  return false;
};

export const isLicenseViewEnabledForUser = (
  key: string,
  flags: LDFlagSet | undefined,
  userId: string | undefined,
  emailId: string | undefined
): boolean => {
  if (!userId && !emailId) {
    return false;
  }

  const featureFlag = flags ? flags[key] : undefined;
  if (featureFlag === undefined) {
    return false;
  }
  if (Array.isArray(featureFlag) && featureFlag.length === 0) {
    return true;
  }
  if (Array.isArray(featureFlag) && featureFlag.length > 0) {
    // Check if provided userId or emailId is in the list
    const isUserInList = featureFlag.some(
      (flagValue: string) => {
        const flagValueLower = flagValue.toLowerCase();
        return (userId && flagValueLower === userId.toLowerCase()) ||
               (emailId && flagValueLower === emailId.toLowerCase());
      }
    );
    return isUserInList;
  }
  return false;
};

/**
 * Checks whether the legacy workflow should be shown for a given site.
 * The LaunchDarkly flag is a JSON flag with the format: { "siteIds": ["site-id-1", "site-id-2"] }
 * Returns true when the provided siteId is present in the flag's siteIds list.
 */
export const isLegacyWorkflowEnabledForSite = (
  key: string,
  flags: LDFlagSet | undefined,
  siteId: string | null
): boolean => {
  if (!siteId) return false;
  const featureFlag = flags ? flags[key] : undefined;
  if (!featureFlag) return false;
  const siteIds: string[] = featureFlag?.siteIds ?? [];
  return Array.isArray(siteIds) && siteIds.some(
    (id: string) => id.toLowerCase() === siteId.toLowerCase()
  );
};